import styled from 'styled-components';
import { IThemeProvider } from '../../../../../styles/theme';

export const BarWrapper = styled.div`
  position: relative;
  width: 100%;
  padding-top: 62px;
`;

export const PinCont = styled.div<{ position: number }>`
  position: absolute;
  top: 0;
  height: 62px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
  left: ${({ position }) => position}%;
  transform: translateX(-50%);
  transition: left 0.5s;
  transition-timing-function: cubic-bezier(0.17, 0.67, 0.83, 0.67);
`;

export const ScoreBubble = styled.div<{ color: string }>`
  width: 44px;
  height: 44px;
  border-radius: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: 700;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.15);
  ${({ theme, color }) => `
    background: ${color};
    color: ${theme.colors.neutral.primary[0]};
  `}
`;

export const PinTriangle = styled.div<{ color: string }>`
  margin-top: 6px;
  width: 0;
  height: 0;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-top: 6px solid ${({ color }) => color};
`;

export const Track = styled.div`
  display: flex;
  height: 14px;
  border-radius: 7px;
  overflow: hidden;
`;

interface ITrackSegment extends IThemeProvider {
  width: number;
  color: string;
  withDivider: boolean;
}

export const TrackSegment = styled.div<ITrackSegment>`
  width: ${({ width }) => width}%;
  ${({ theme, color, withDivider }) => `
    background: ${color};
    ${withDivider ? `border-right: 2px solid ${theme.colors.neutral.primary[0]};` : ''}
  `}
`;

export const TicksRow = styled.div`
  position: relative;
  margin-top: 10px;
  height: 16px;
`;

interface ITick extends IThemeProvider {
  position: number;
  align: 'start' | 'middle' | 'end';
}

const TICK_TRANSFORMS = {
  start: 'none',
  middle: 'translateX(-50%)',
  end: 'translateX(-100%)',
};

export const Tick = styled.span<ITick>`
  position: absolute;
  font-size: 12px;
  left: ${({ position }) => position}%;
  transform: ${({ align }) => TICK_TRANSFORMS[align]};
  ${({ theme }) => `
    color: ${theme.colors.neutral.primary[60]};
  `}
`;
